import React from 'react';
import { Wrench, Clock, Shield, MapPin, Star, GlassWater } from 'lucide-react';

const Benefits = () => {
  return (
    <section className="py-24 md:py-32 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Pourquoi choisir Suro Phone ?</h2>
          <p className="text-lg text-gray-600">Qualité professionnelle, prix compétitifs</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-xl hover:shadow-lg transition-shadow">
            <Wrench className="w-12 h-12 text-blue-500 mb-4" />
            <h3 className="text-xl font-bold text-gray-900 mb-3">Pièces Premium</h3>
            <p className="text-gray-600">
              Toutes nos pièces sont testées avant et pendant la réparation. Nous n'utilisons que du matériel de qualité.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl hover:shadow-lg transition-shadow">
            <Clock className="w-12 h-12 text-blue-500 mb-4" />
            <h3 className="text-xl font-bold text-gray-900 mb-3">Réparation rapide</h3>
            <p className="text-gray-600">
              Votre téléphone réparé le jour même dans la plupart des cas. Nous nous engageons sur des délais courts.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl hover:shadow-lg transition-shadow">
            <Shield className="w-12 h-12 text-blue-500 mb-4" />
            <h3 className="text-xl font-bold text-gray-900 mb-3">Garantie 3 mois</h3>
            <p className="text-gray-600">
              Toutes nos réparations sont garanties 3 mois en cas de dysfonctionnement. Nous garantissons notre travail.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl hover:shadow-lg transition-shadow">
            <MapPin className="w-12 h-12 text-blue-500 mb-4" />
            <h3 className="text-xl font-bold text-gray-900 mb-3">À domicile</h3>
            <p className="text-gray-600">
              Nous nous déplaçons à votre adresse si vous ne pouvez pas venir à l'atelier de Saint-Chamond.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl hover:shadow-lg transition-shadow">
            <Star className="w-12 h-12 text-blue-500 mb-4" />
            <h3 className="text-xl font-bold text-gray-900 mb-3">+1000 réparations</h3>
            <p className="text-gray-600">
              L'expérience compte. Nous avons déjà réparé plus de 1000 smartphones avec succès.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl hover:shadow-lg transition-shadow">
            <GlassWater className="w-12 h-12 text-green-500 mb-4" />
            <h3 className="text-xl font-bold text-gray-900 mb-3">Éco-responsable</h3>
            <p className="text-gray-600">
              Réparer plutôt que jeter. Chaque téléphone réparé, c'est moins de déchets électroniques.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;